<template>
    <div v-if="!check_log && !logged" id="login" ref="login">
        <form class="box" id="login-form" method="post" ref="login-form" v-on:submit="login">
            <h3 v-text="$ml.get('login.title')"></h3>
            <ul>
                <li>
                    <label for="email" v-text="$ml.get('login.email')"></label>
                    <input id="email" name="email" :placeholder="$ml.get('login.email')" ref="email" required type="email">
                </li>
                <li>
                    <label for="password" v-text="$ml.get('login.password')"></label>
                    <input autocomplete="off" id="password" name="password" :placeholder="$ml.get('login.password')" ref="password" required type="password">
                </li>
                <li>
                    <div v-if="error" id="error">{{ error }}</div>
                    <input ref="btn-submit" type="submit" :value="btn_submit_value">
                </li>
                <li><router-link class="btn-1" to="/cadastro" ref="btn-close" v-text="$ml.get('login.register')"></router-link></li>
                <li><router-link class="btn-0" to="/" ref="btn-close" v-text="$ml.get('login.close')"></router-link></li>
            </ul>
        </form>
    </div>
</template>
<script>
    import axios from 'axios';
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Entrar",
        computed: {
            ...mapGetters([
                'token', 'logged', 'check_log'
            ])
        },
        data() {
            return {
                btn_submit      : false,
                btn_submit_value: this.$ml.get('login.send'),
                error           : null
            }
        },
        methods: {
            ...mapActions([
                'update', 'update_profile'
            ]),
            block(v) {
                this.btn_submit_value = (v ? (this.$ml.get('login.wait') + "...") : this.$ml.get('login.send'));
                this.$refs["btn-submit"].style.pointerEvents = (v ? 'none' : 'auto');
                this.$refs["btn-submit"].style.opacity = (v ? '.4' : '1');
            },
            login(e) {
                //this.$parent.wait(true);
                this.error = null;
                if (!/^([A-Za-z0-9_\-.+])+@([A-Za-z0-9.])+\.([A-Za-z]{2,})$/.test(this.$refs["email"].value)) {
                    //this.error = 'O campo "E-mail" deve ser um endereço de e-mail válido.';
                    this.error = this.$ml.get('login.form_0');
                } else if (this.$refs["password"].value.length < 3) {
                    //this.error = 'Mínimo de 3 letras para sua senha.';
                    this.error = this.$ml.get('login.form_1');
                }
                if (this.error) {
                    e.preventDefault();
                } else {
                    this.sendLogin(e);
                }
            },
            sendLogin(e) {
                if (!this.submit) {
                    this.block(true);
                    let form_data = new FormData(this.$refs["login-form"]);
                    axios.post(this.$url + 'php/login.php', form_data).then(response => this.loginResponse(response));
                }
                e.preventDefault();
            },
            loginResponse(obj) {
                if (obj.data.access_token) {
                    this.update(obj.data.access_token);
                    this.update_profile({ id: obj.data.id, email: obj.data.email, first_name: obj.data.firstName, last_name: obj.data.lastName });
                    this.$parent.user_info = obj.data.firstName + " " + obj.data.lastName;
                    this.$parent.getCart();
                    this.$parent.getPoints();
                    this.$parent.saveUser(obj.data);
                    this.$router.push('/');
                } else if (obj.data.error) {
                    this.error = obj.data.error;
                }
                else if ((obj.data === "") || (obj.data === null) || (obj.data === "null")) {
                   // this.error = "Não foi possível logar com esse e-mail e senha.";
                   this.error = this.$ml.get('login.login_error');
                }
                this.block(false);
            }
        },
        mounted() {
            this.$refs['email'].focus();
        },
        updated() {
            this.btn_submit_value = this.$ml.get('login.send');
        }
    }
</script>

<style scoped>
    #login
    {
        background-color: rgba(0, 0, 0, .6);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        overflow-y:scroll;
    }

    form
    {
        box-sizing: border-box;
        display: block;
        margin: 150px auto;
        max-width: 400px;
        padding: 30px;
    }
    form ul li
    {
        box-sizing: border-box;
        padding: 10px 0;
    }

    #error
    {
        box-sizing: border-box;
        color: red;
        display: block;
        padding: 10px;
        text-align: center;
    }

    @media screen and (max-width: 500px)
    {
        form
        {
            width: calc(100% - 40px);
        }
    }

</style>